// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__O-knO","messages":"Chat_messages__2TlK-","dateDivider":"Chat_dateDivider__1YiUs"};